// extracted by mini-css-extract-plugin
export var closeButton = "_n8-2";
export var closeButtonIcon = "_n8-3";
export var lightboxContent = "_n8-1";
export var lightboxOverlay = "_n8-0";